<!--
* @Author: zhangping
* @Date: 2026-01-29 15:28:06
* @Description: 最近活动
-->

<template>
    <div>
        <CheckboxGroup v-model="activityId" @on-change="onChange" class="checkboxGroup">
            <Checkbox
                v-for="(item, index) in activityList"
                :key="item.id"
                :label="item.id"
                border
                class="cup"
                :class="[index < activityList.length - 1 ? 'mr-5 mb-5' : 'mr-0']"
            >
                {{ item.name }}
            </Checkbox>
        </CheckboxGroup>
    </div>
</template>

<script>
import { apiSpecialOrderRecentActive } from '@/api/sales';
export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            activityId: [],
            activityList: [],
        };
    },
    mounted() {
        this.getRecentlyActivityList();
    },
    watch: {
        value: {
            handler(val) {
                this.activityId = this.value;
            },
            immediate: true,
        },
    },
    methods: {
        // 获取-最近活动列表
        async getRecentlyActivityList() {
            try {
                const res = await apiSpecialOrderRecentActive();
                this.activityList = res;
                if (res.length === 0) {
                    this.$nextTick(() => {
                        this.$bus.$emit('recentlyActivityIsZero');
                    });
                }
            } catch (err) {}
        },
        // change-选项时
        onChange(val) {
            this.$emit('onChange', val);
        },
    },
};
</script>

<style lang="less" scoped>
.checkboxGroup {
    .ivu-checkbox-wrapper {
        padding: 0 5px;
        line-height: 26px;
        height: 28px;
    }
    .ivu-checkbox-wrapper-checked {
        color: #2d8cf0;
    }
    /deep/ .ivu-checkbox {
        display: none !important;
    }
}
</style>
